import React from 'react';
import {Button, Table} from "react-bootstrap";
import animateScrollTo from "animated-scroll-to";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faTimes} from "@fortawesome/free-solid-svg-icons";

interface RoomsProps {
    roomsRef: React.MutableRefObject<HTMLDivElement[]>;
    rooms: any[];
    roomTypes: any[];
    cableTrayOptions: any[];
    floorTypes: any[];
    addRoom: () => void;
    removeRoom: (index: number) => void;
    currentItem: string;
    roomsSurfaces: number[];
}

const Rooms = (props: RoomsProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {rooms, roomsRef, roomTypes, cableTrayOptions, floorTypes, addRoom, removeRoom, currentItem, roomsSurfaces} = props;
    return <div id={'viewer'}>
        <h1>Kamers</h1>
        <Table id={'roomTable'} striped hover responsive>
            <thead>
            <tr>
                <th>#</th>
                <th>Kamertype</th>
                <th>Oppervlakte</th>
                <th>Verdieping</th>
                {/*<th>Kabelgoot</th>*/}
                <th>Verwijder</th>
            </tr>
            </thead>
            <tbody>
            {rooms.map((room, i) => <tr key={i} onClick={() => animateScrollTo(roomsRef.current[i].offsetTop - 70)} className={currentItem === 'room:' + i ? 'bg-main text-white' : ''}>
                <td>{i + 1}</td>
                <td>{roomTypes.filter(type => type.key === room.type)[0].name}</td>
                <td>{roomsSurfaces[i]} m²</td>
                <td>{floorTypes.filter(type => type.key === room.floor)[0].name}</td>
                {/*<td>{cableTrayOptions.filter(type => type.key === room.cableTrayType)[0].name}</td>*/}
                <td>
                    <Button variant={'danger'} disabled={rooms.length === 1} onClick={(event) => {
                        event.stopPropagation();
                        removeRoom(i);
                    }}>
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </td>
            </tr>)}
            </tbody>
        </Table>
        <Button variant={'main'} onClick={addRoom}><FontAwesomeIcon icon={faPlus} /> Kamer toevoegen</Button>
        <div style={{height: 100}} />
    </div>;
}

export default Rooms;